import React, { useState, useEffect } from 'react';
import {
	Card,
	Callout,
	XhrStatus,
    useAjax,
	TranslatedString
} from '@bosch/bt-ui';

import './PanelEnvironmentPage.css';
import withErrorHandler from '../../components/ErrorHandler';
import PathfinderHelper from './Component/PathfinderHelper';
import PanelIdLookupHelper from './Component/PanelIdLookupHelper';

const PanelEnvironmentPage = (props) => {
	const {
		token,
		isLoggedIn
	} = props;

	const [pathfinderUpdateStatus, setPathfinderUpdateStatus] = useState(null);
	const [pathfinderInfoResult, pathfinderInfoStatus, getPathfinderInfo, pathfinderResponse] = useAjax(XhrStatus.Initial);
	const [pathfinderInfoExternalResult, setPathfinderInfoExternalResult] = useState(null) // set the result state outside of useAjax
	const [panelIdResult, panelIdStatus, getDeviceDomainMappings, panelIdResponse] = useAjax(XhrStatus.Initial);

	useEffect(() => {
		setPathfinderInfoExternalResult(pathfinderInfoResult);
	}, [pathfinderInfoResult]);
	
	const callOutMessage = (status) => {
		if (status == 200){
			return <Callout type="success">
				{status} : <TranslatedString stringId="pathfinder-update-successfully" />
			</Callout>
		} else if (status == 500) {
			return <Callout type="error">
				{status} : <TranslatedString stringId="pathfinder-update-failed" />
			</Callout>
		} else {
			return <Callout type="error">
				<TranslatedString stringId="please-contact-admin" />
			</Callout>
		}
	}

	return (
		<Card
			background="secondary"
			htmlAttributes={{
				id: 'panel-environment-page',
			}}>
			{ (pathfinderUpdateStatus == 403 || pathfinderResponse?.status == 403 || panelIdResponse?.status == 403) && <Callout type="error">
				{pathfinderUpdateStatus} : <TranslatedString stringId="no-access-msg" />
			</Callout>}
            {
                pathfinderUpdateStatus && pathfinderUpdateStatus != 403 && callOutMessage(pathfinderUpdateStatus)
			}
			<PathfinderHelper
				token={token}
				isLoggedIn={isLoggedIn}
				setPathfinderUpdateStatus={setPathfinderUpdateStatus}
				pathfinderInfoExternalResult={pathfinderInfoExternalResult}
				setPathfinderInfoExternalResult={setPathfinderInfoExternalResult}
				pathfinderInfoStatus={pathfinderInfoStatus}
				getPathfinderInfo={getPathfinderInfo}
			/>
			<PanelIdLookupHelper
				token={token}
				isLoggedIn={isLoggedIn}
				panelIdResult={panelIdResult}
				panelIdStatus={panelIdStatus}
				getDeviceDomainMappings={getDeviceDomainMappings}
			/>
		</Card>
	);
};

export default withErrorHandler(React.memo(PanelEnvironmentPage));